//==========================================
//⚠️ Keep index files under 100 lines!
//Split logic into submodules as needed.
//==========================================
import { createContext, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ADMIN_ROLE } from "../../global/constants/commonConstants";
import { clearExpandedEvent, eventError, getAllEvents } from "../../store/actions";
import DashboardHeader from "./DateComponent";
import EbcLeftContainer from "./EbcLeftContainer";
import FloorContainer from "./FloorContainer";
import GettingStartedModal from "./GettingStartedModal";
import { Container, Header } from "./styles";
import WidgetsContainer from "./WidgetContainer";
import { STORAGE } from "../../global/constants/storageConstants";
import WidgetComponent from "../Statistics/WidgetComponent";
import { ROUTES, SAFE_REDIRECT_ROUTES } from "../../global/constants/routesConstants";
export const SiteContext = createContext();

const WIDGET_LIST = [{"id": "26938","name":"Crowd counting_crowdcounting_stat_lvl1_1121",
  "secureShareUrl": "E5Z75WK7iptE9XnLzY9dJKBQBokUHLK9Z5Q2Dnip392n0ie","shareUrl": ""}];

const Dashboard = () => {
  const dispatch = useDispatch();
  const [isSingleSite, setIsSingleSite] = useState(false);
  const [initialSiteTag, setInitialSiteTag] = useState();
  const [initialFloorTag, setInitialFloorTag] = useState();
  const [sitesList, setSitesList] = useState([]);
  const [widgetEncryptPayload, setWidgetEncryptPayload] = useState(null);
  // True once user manually picks a site from the dropdown — blocks incoming events from
  // auto-switching the floor map away from the user's chosen site.
  const userSelectedSiteRef = useRef(false);
  const { activeSession } = useSelector((state) => state.sessionReducer.activeSession);
  const rurl = sessionStorage.getItem(STORAGE.RURL);
  const navigate = useNavigate();
  const { siteTagList } = useSelector((state) => state?.sitesReducer);
  const sites = siteTagList?.sites;

  /**
   * Memoize the sites Array to prevent from re-running.
   * Unless any value of site object changes.
   */
  const processedSites = useMemo(() => {
    if (!sites || !Array.isArray(sites)) return [];

    return sites.map((site) => ({
      id: site.id,
      kind: site.kind,
      name: site.name,
      tagids: site.tagids || []
    }));
  }, [sites]);

  useEffect(() => {
    const userRole = JSON.parse(sessionStorage.getItem(STORAGE.SELECTED_ROLE));
    if (processedSites && processedSites.length && userRole !== ADMIN_ROLE) {
      setSitesList(processedSites);
    } else {
      setSitesList([]);
    }
  }, [processedSites?.length]);

  useEffect(() => {
    // Clear any persisted error state from the previous session on mount
    dispatch(eventError(false));

    return () => {
      dispatch(eventError(false));
      dispatch(clearExpandedEvent());
    };
  }, []);

  // Drop any stale manual-site lock from a previous account — otherwise it could
  // silently block auto-follow for the newly switched-to account.
  useEffect(() => {
    userSelectedSiteRef.current = false;
  }, [activeSession?.accountId]);

  // Capture widget payload once on first valid initialSiteTag — never update after.
  useEffect(() => {
    if (initialSiteTag != undefined && !widgetEncryptPayload) {
      setWidgetEncryptPayload({
        accountname: activeSession?.accountId,
        tagid: sites?.length ? sites[0]?.id : "",
        startDate: new Date(Date.now()).toISOString(),
        eeFixedInterval: "1h",
        endDate: new Date(Date.now() + 1 * 60 * 1000).toISOString(),
        xAxisDateFormat: "hh:mmA",
        getTagsKind: sites?.length === 1 ? "ts.tag.floor" : "ts.tag.site",
        eventfield: "fields.crowdcounting.resolutionTime",
        eventfieldForPriority: "fields.crowdcounting.severity",
        objectClass: "",
        tagIdList: "id~" + initialSiteTag + "=name~" + (sites?.find((f) => f?.id === initialSiteTag)?.name || "")
      });
    }
  }, [initialSiteTag]);

  return (
    <>
      <GettingStartedModal />
      <Header>
        <DashboardHeader />
      </Header>
      <SiteContext.Provider value={{ isSingleSite, setIsSingleSite }}>
        <Container>
          <EbcLeftContainer setInitialSiteTag={setInitialSiteTag} initialSiteTag={initialSiteTag} setInitialFloorTag={setInitialFloorTag} initialFloorTag={initialFloorTag} sitesList={sitesList} userSelectedSiteRef={userSelectedSiteRef} />
          <FloorContainer initialSiteTag={initialSiteTag} setInitialSiteTag={setInitialSiteTag} initialFloorTag={initialFloorTag} setInitialFloorTag={setInitialFloorTag} userSelectedSiteRef={userSelectedSiteRef} />
          <WidgetsContainer />
        </Container>
      </SiteContext.Provider>

       {widgetEncryptPayload && <div style={{display: "none"}} >Test First Widget load
            <WidgetComponent
              widgetList={WIDGET_LIST}
              showHideFilter={true}
              encryptPayload={widgetEncryptPayload}
              aggregatedCVAppCount={1}
              selectedCVAppName={"Crowd Counting"}
            ></WidgetComponent>
            </div>}
    </>
  );
};

export default Dashboard;
